import React from 'react'

function GptMovieSuggestions() {
  return (
    <div>GptMovieSuggestions</div>
  )
}

export default GptMovieSuggestions